import { Permission } from '@src/main/modules/roles/domain/permission.interface';
import { PermissionRepository } from '@src/main/modules/roles/domain/permission.repository';

export const findAllPermissions = async (repository: PermissionRepository): Promise<Permission[]> =>
  await repository.findAll();
